import scribeBrainLogo from '@/assets/scribebrain-logo.png';
import { Logout } from '@/components/auth/logout';
import { HistoryIcon } from '@/components/icons';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { headerStyles } from './styles';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isOnHistoryPage = location.pathname === '/history';

  const handleHistoryToggle = () => {
    if (isOnHistoryPage) {
      // Dispatch event to save current state before closing
      window.dispatchEvent(new CustomEvent('saveHistoryState'));
      navigate('/portal');
    } else {
      navigate('/history');
    }
  };

  const handleLogoClick = () => {
    navigate('/portal');
  };

  return (
    <Box sx={headerStyles.container}>
      <Box
        component="img"
        src={scribeBrainLogo}
        alt="ScribeBrain Logo"
        sx={headerStyles.logo}
        onClick={handleLogoClick}
      />
      <Box sx={headerStyles.actionsContainer}>
        <Box sx={headerStyles.showHistoryButton} onClick={handleHistoryToggle}>
          <Box sx={headerStyles.iconContainer}>
            <HistoryIcon width={20.3} height={18} />
          </Box>
          <Box component="span" sx={headerStyles.showHistoryText}>
            {isOnHistoryPage ? 'Close History' : 'Show History'}
          </Box>
        </Box>
        <Logout />
      </Box>
    </Box>
  );
};

export default Header;
